module.exports = __webpack_public_path__ + "media/images/icn-lock-08cc62c11327bfb36d23add88bcd99d1.png";